export const VUE_APP_PARTNER_SMALL_FOUNDATION = "smallfoundation";
export const VUE_APP_PARTNER_ESO = "eso";
export const VUE_APP_PARTNER_CASE = "case";
export const VUE_APP_PARTNER_MAINSTREET = "mainstreet";
